export const countryProfile = {
  countrySummary: {
    text: "Country Summary",
    keyContacts: "Key Contacts",
    resources: "Resources",
  },
  exportCountryDataButton: "Export Country Data",
  downloadScorecard: "Download Scorecard",
  overallDigitalHealthPhase: "Overall Digital Health Phase",
  overallDigitalHealthPhaseDescription:
    "The overall score is an average of the scores for the GDHM indicators",
  benchmark: {
    text: "Benchmark",
    textWithData: "Benchmark: {data}",
    benchmarkValues: {
      globalAverage: "Global Average",
      atAvg: "AT AVG.",
      belowAvg: "BELOW AVG.",
      aboveAvg: "ABOVE AVG.",
    },
    benchmarkDescription:
      "Compare your overall score with Global Average or other phase countries",
    benchmarkNoCountryForSelectedPhase:
      "No countries in the selected phase for benchmarking",
    serverErrorDescription:
      "Unable to load benchmark data. Please try after sometime",
    average: "Average",
  },
  indicator: "Indicator",
  score: "Score",
  govtData: "Government Approved",
  nonGovtData: "Pending Government Approval",
  selectYear: "Select Year",
  selectYearDescription:
    "To view data for a specific year, please select the desired year",
  phaseOverview: "Phase Overview",
  countryProgressOverTime: "Country Progress Over Time",
  countryProgressLineChart: {
    indicatorGroupingDescription: "Select an indicator",
    globalAverage: "Global average",
  },
  compareTo: "Compare to",
  region: "Region",
};
